/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';
import { Billing } from '../../models/billing';

export interface BillingSubmitCharges$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
      body: Billing
}

export function billingSubmitCharges(http: HttpClient, rootUrl: string, params: BillingSubmitCharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, billingSubmitCharges.PATH, 'post');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

billingSubmitCharges.PATH = '/billing/submitcharges';
